module.exports = __webpack_public_path__ + "img/unicoin_cointreasure.80d3bf4.png";